import { useCallback } from 'react'
import MenuItem from '@mui/material/MenuItem'

import { authClient } from '@/lib/auth/custom/client'
import { logger } from '@/lib/default-logger'
import { useUser } from '@/hooks/use-user'
import { toast } from '@/components/core/toaster'

export function CustomSignOut() {
	const { checkSession } = useUser()

	const handleSignOut = useCallback(async (): Promise<void> => {
		try {
			const { error } = await authClient.signOut()

			if (error) {
				logger.error('Sign out error', error)
				toast.error('Something went wrong, unable to sign out')
				return
			}

			// Refresh the auth state
			await checkSession?.()
			// After refresh, GuestGuard will handle the redirect
		} catch (err) {
			logger.error('Sign out error', err)
			toast.error('Something went wrong, unable to sign out')
		}
	}, [checkSession])

	return (
		<MenuItem component="div" onClick={handleSignOut} sx={{ justifyContent: 'center' }}>
			Sign out
		</MenuItem>
	)
}
